export default __webpack_public_path__ + "static/media/Logo_USClubSoccer.0ffea03a.png";